import { render, staticRenderFns } from "./delivNoteTab.vue?vue&type=template&id=3c46f5e0&scoped=true"
import script from "./delivNoteTab.vue?vue&type=script&lang=js"
export * from "./delivNoteTab.vue?vue&type=script&lang=js"
import style0 from "./delivNoteTab.vue?vue&type=style&index=0&id=3c46f5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c46f5e0",
  null
  
)

export default component.exports